import { fetchFromUrl } from './urlFunctions';

const getQuestions = async () => (await fetchFromUrl('/questions/get_all', { method: 'POST' }));

export {
    getQuestions
};
